import { useDispatch, useSelector } from "react-redux";

// Custom hook to access the Redux store's state
export const useAppSelector = useSelector;

// Custom hook to access the Redux store's dispatch function
export const useAppDispatch = () => useDispatch();
